<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deletePatient" @cancel="cancel" />
    <v-data-table
      :headers="tbHeaders"
      :items="referPresumptiveData"
      :items-per-page="itemsPerPage"
      :loading="loading"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              <span v-if="header.value">{{ header.text }}</span>
            </th>
            <th class="header--text">Actions</th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>

          <td>
            <span v-if="item.existing_presumptive == 1">{{ item.name }}</span>
            <span v-else-if="item.existing_presumptive == 2">{{
              item.existing_presumptive_data.name
            }}</span>
          </td>
          <td>
            <span v-if="item.existing_presumptive == 1">{{ item.age }}</span>
            <span v-else-if="item.existing_presumptive == 2">{{
              item.existing_presumptive_data.age
            }}</span>
          </td>
          <td>
            <span v-if="item.existing_presumptive == 1">{{
              item.sex == 1 ? "Male" : "Female"
            }}</span>
            <span v-else-if="item.existing_presumptive == 2">{{
              item.existing_presumptive_data.sex == 1 ? "Male" : "Female"
            }}</span>
          </td>

          <td>
            {{ item.volunteer ? item.volunteer.code : "" }} ({{
              item.volunteer ? item.volunteer.name : ""
            }})
          </td>
          <td>{{ item.referral_date }}</td>
          <td>{{ item.case_found_at_name.name }}</td>
          <td>
            <span v-if="item.confirm == 1">Presumptive</span>
            <span v-if="item.confirm == 0">Refer </span>
          </td>
          <td>
            <v-btn
              @click="goToPresumptive(item)"
              icon
              color="orange darken-1"
              class="mr-2 white--text"
              depressed
            >
              <v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>

            <v-btn
              v-show="item.confirm == 0"
              @click="goUpdateForm(item)"
              icon
              color="orange darken-1"
              class="mr-2 white--text"
              depressed
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn>
            <v-btn
              v-show="item.confirm == 0"
              @click="openConfrimBox(item)"
              icon
              color="red lighten-1"
              class="white--text"
              depressed
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import ConfirmBox from "@/components/notification/ConfirmBox";

import { mapState } from "vuex";
export default {
  components: {
    ConfirmBox,
  },
  data: () => ({
    item: {},
    dialog: false,
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    tbHeaders: [
      { text: "No", value: "no" },
      { text: "Name", value: "name" },
      { text: "Age", value: "age" },
      { text: "Sex", value: "sex" },
      { text: "Volunteer", value: "volunteer" },
      { text: "Referral Date", value: "referral_date" },
      { text: "Case Found At", value: "case_found_at" },
      { text: "Status", value: "status" },
    ],
  }),
  computed: {
    ...mapState("PresumptiveRefer", ["referPresumptiveData"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deletePatient() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("PresumptiveRefer/deleteReferPatient", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push(
        `/presumptive-referral/edit/${item.id}/${item.township_id}`
      );
    },

    goToPresumptive(item) {
      if (item.confirm == 0) {
        if (item.existing_presumptive == 1) {
          this.$router.push(`/save-as-presumptive/${item.id}/REFERRAL`);
        } else if (item.existing_presumptive == 2) {
          this.$router.push(`/save-as-presumptive/${item.id}/Existing`);
        }
      } else {
        if (item.existing_presumptive == 1)
          this.$router.push(`/presumptive-detail/${item.id}`);
        else
          this.$router.push(
            `/presumptive-detail/${item.existing_presumptive_id}`
          );
      }
    },
  },
};
</script>

<style>
</style>